import { SET_CHOSEN_SUBTITLE } from "./types"

export const setChosenSubtitle = (chosenSubtitle) => {
    return {
        type: SET_CHOSEN_SUBTITLE,
        payload: chosenSubtitle
    }
}